import {ethers} from 'ethers';
import Config from '@/assets/js/config/load';

const config = Config();

let ETSCProvider = new ethers.providers.JsonRpcProvider(config.web3.provider.ETSC);

export async function getBalance(address) {
    return await ETSCProvider.getBalance(address);
}

export async function getBlockNumber() {
    return await ETSCProvider.getBlockNumber();
}

export async function getBlock(number) {
    return await ETSCProvider.getBlock(parseInt(number));
}

export async function isContract(address) {
    let code = await ETSCProvider.getCode(address);
    if (code !== '0x') {
        return 1;
    } else {
        return 0;
    }
}

export async function getTransactionCount(address) {
    return await ETSCProvider.getTransactionCount(address);
}

export async function getETSLBalance(address) {
    let abi = config.ETSL.abi;
    let contractAddress = config.ETSL.address;
    let contract = new ethers.Contract(contractAddress, abi, ETSCProvider);
    let res = await contract.balanceOf(address);
    return ethers.utils.formatEther(res);
}

export async function getMPLBalance(address) {
    let abi = config.MPL.abi;
    let contractAddress = config.MPL.address;
    let contract = new ethers.Contract(contractAddress, abi, ETSCProvider);
    let res = await contract.balanceOf(address);
    return ethers.utils.formatEther(res);
}

export async function getppsBalance(address) {
    let abi = config.pps.abi;
    let contractAddress = config.pps.address;
    let contract = new ethers.Contract(contractAddress, abi, ETSCProvider);
    let res = await contract.balanceOf(address);
    return ethers.utils.formatEther(res);
}

export async function getPPSBalance(address) {
    let abi = config.PPS.abi;
    let contractAddress = config.PPS.address;
    let contract = new ethers.Contract(contractAddress, abi, ETSCProvider);
    let res = await contract.balanceOf(address);
    return ethers.utils.formatEther(res);
}

export async function getCMCBalance(address) {
    let abi = config.CMC.abi;
    let contractAddress = config.CMC.address;
    let contract = new ethers.Contract(contractAddress, abi, ETSCProvider);
    let res = await contract.balanceOf(address);
    return ethers.utils.formatEther(res);
}
export async function getFCTBalance(address) {
    let abi = config.FCT.abi;
    let contractAddress = config.FCT.address;
    let contract = new ethers.Contract(contractAddress, abi, ETSCProvider);
    let res = await contract.balanceOf(address);
    return ethers.utils.formatEther(res);
}
export async function getNBCBalance(address) {
    let abi = config.NBC.abi;
    let contractAddress = config.NBC.address;
    let contract = new ethers.Contract(contractAddress, abi, ETSCProvider);
    let res = await contract.balanceOf(address);
    return ethers.utils.formatEther(res);
}
export async function getNBABalance(address) {
    let abi = config.NBC.abi;
    let contractAddress = config.NBC.addressNba;
    let contract = new ethers.Contract(contractAddress, abi, ETSCProvider);
    let res = await contract.balanceOf(address);
    return ethers.utils.formatEther(res);
}

export async function getFGCBalance(address) {
    let abi = config.NBC.abi;
    let contractAddress = config.NBC.addressFgcc;
    let contract = new ethers.Contract(contractAddress, abi, ETSCProvider);
    let res = await contract.balanceOf(address);
    return ethers.utils.formatEther(res);
}

export async function getFGC3Balance(address) {
    let abi = config.NBC.abi;
    let contractAddress = config.NBC.addressFgc3;
    let contract = new ethers.Contract(contractAddress, abi, ETSCProvider);
    let res = await contract.balanceOf(address);
    return ethers.utils.formatEther(res);
}
export async function getNBC3Balance(address) {
    let abi = config.NBC.abi;
    let contractAddress = config.NBC.addressNbc3;
    let contract = new ethers.Contract(contractAddress, abi, ETSCProvider);
    let res = await contract.balanceOf(address);
    return ethers.utils.formatEther(res);
}
export async function getNBBBalance(address) {
    let abi = config.NBC.abi;
    let contractAddress = config.NBC.addressNbb;
    let contract = new ethers.Contract(contractAddress, abi, ETSCProvider);
    let res = await contract.balanceOf(address);
    return ethers.utils.formatEther(res);
}

export async function getEUSDBalance(address) {
    let abi = config.EUSD.abi;
    let contractAddress = config.EUSD.address;
    let contract = new ethers.Contract(contractAddress, abi, ETSCProvider);
    let res = await contract.balanceOf(address);
    return ethers.utils.formatUnits(res, 6);
}

export async function getETHCBalance(address) {
    let abi = config.ETHC.abi;
    let contractAddress = config.ETHC.address;
    let contract = new ethers.Contract(contractAddress, abi, ETSCProvider);
    let res = await contract.balanceOf(address);
    return ethers.utils.formatEther(res);
}